import type { DependencyList, RefObject } from 'react';
import { useRefs as useRefs_ } from '@halo/hooks';

/**
 * @deprecated
 * @see import { useRefs } from '@halo/hooks';
 */
export const useRefs = useRefs_;

export function useParentRef<T>(parentRef: RefObject<T> | undefined) {
  const ref = useRef<T>(null);
  return parentRef || ref;
}

export function useFields<T extends MyRecord>(fields: T, deps: DependencyList = []) {
  const { t } = useTranslation();

  const cacheFunctionRef = useRef<MyRecord>({});

  const fields_ = useMemo(() => {
    const cache: MyRecord = {};
    return new Proxy(fields, {
      get(target, p: any) {
        if (p in cache) {
          return cache[p];
        }

        const cacheFunction = cacheFunctionRef.current;
        if (p in cacheFunction) {
          return cacheFunction[p];
        }

        let value = target[p];

        if (typeof value === 'function') {
          value = value.bind(target);
          cacheFunction[p] = value;
        } else {
          cache[p] = value;
        }

        return value;
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fields, t, ...deps]);
  return fields_;
}

export * from './usePortalContainer';
export * from './useContactsQuery';
export * from './useCountries';
export * from './useOpenLink';
export * from './useReducerStore';
export * from './useMediaError';

export { useIsMe, useIsMyMsg, useMsg, useUserInfo, useUserInfoList } from '@halo/chat-sdk-react';
